module.exports = __webpack_public_path__ + "img/banner-nosotros.abe2e225.jpg";